<!-- 设备列表页面 -->
<template>
  <div class="vcnDeviceList vcnDevicelist_warpd">
    <!--主页面 -->
    <div class="flex-row" style="height: 100%">
      <!-- 左侧树 -->
      <div class="section-mian_left tree-line-style">
        <el-scrollbar style="height: 100%">
          <el-tree
            :data="frame"
            :props="treeProps"
            class="shebeiDiv"
            @node-click="currentChange"
            :expand-on-click-node="true"
            :default-expand-all="false"
            :default-expanded-keys="['1']"
            :highlight-current="true"
            node-key="thirdDeviceId"
            ref="vuetree"
          ></el-tree>
        </el-scrollbar>
      </div>

      <!-- 右侧表单 -->
      <div class="section-mian_right">
        <!-- 头部按钮 -->
        <div class="section-mian__toolbar">
          <el-button
            type="primary"
            class="iss-operation-button"
            icon="iconfont icon-iconfontfanhui"
            @click="retBtn"
            >{{ $t("deviceAccess.button.back") }}</el-button
          >
          <el-button
            type="primary"
            class="iss-operation-button"
            icon="iconfont icon-daoru"
            @click="synData"
            v-auth="'/deviceaccess/index:syncDevice'"
            >{{ $t("deviceAccess.button.sync") }}</el-button
          >
          <el-button
            type="primary"
            class="iss-operation-button"
            icon="el-icon-delete"
            @click="delDev"
            v-auth="'/deviceaccess/index:deleteDevice'"
            >{{ $t("deviceAccess.button.batchDeletion") }}</el-button
          >
        </div>
        <!-- 搜索框部分 -->
        <div class="section-main__filter">
          <div style="display: flex; justify-content: space-between; align-items: center">
            <div>筛选条件</div>
            <div>
              <el-button
                type="text"
                size="medium"
                style="color: #407aee"
                @click="showSearch = !showSearch"
                :icon="showSearch ? 'el-icon-arrow-up ' : 'el-icon-arrow-down'"
                >{{ !showSearch ? "展开" : "收起" }}</el-button
              >
            </div>
          </div>
          <el-collapse-transition>
            <el-form
              v-show="showSearch"
              ref="searchForm"
              :inline="true"
              :model="queryForm"
              class="demo-form-inline"
            >
              <el-form-item :label="$t('deviceAccess.label.deivcename')">
                <el-input
                  clearable
                  v-model="queryForm.devNumber"
                  :placeholder="$t('deviceAccess.placeholder.deivcename')"
                />
              </el-form-item>
              <el-form-item :label="$t('deviceAccess.label.deviceid')">
                <el-input
                  clearable
                  v-model="queryForm.devId"
                  :placeholder="$t('deviceAccess.placeholder.deviceid')"
                />
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="queryDev">{{
                  $t("deviceAccess.button.query")
                }}</el-button>
                <el-button type="info" @click="resetForm">{{
                  $t("deviceAccess.button.reset")
                }}</el-button>
              </el-form-item>
            </el-form>
          </el-collapse-transition>
        </div>

        <div class="section-main_table">
          <ioc-table
            ref="devTab"
            :data="deviceData"
            :option="deviceOption"
            :page="devicePage"
            @current-change="selectPage"
            @selection-change="selectionChange"
            @size-change="changeSize"
          >
            <!-- 定制操作栏按钮 -->
            <template slot="menu" slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                content="新增"
                placement="top"
                popper-class="tooltip-draw"
              >
                <el-button
                  v-if="scope.row.deviceType == 23"
                  type="text"
                  @click="handleAdd(scope.row)"
                  icon="iconfont icon-Add"
                ></el-button>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                :content="$t('deviceAccess.button.view')"
                placement="top"
                popper-class="tooltip-draw"
              >
                <el-button
                  type="text"
                  @click="seeDel(scope.row)"
                  icon="iconfont icon-Detail"
                ></el-button>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                :content="$t('deviceAccess.button.delete')"
                placement="top"
                popper-class="tooltip-draw"
              >
                <el-button
                  type="text"
                  @click="delDevBtn(scope.row)"
                  icon="iconfont icon-shanchu"
                  v-auth="'/platform:deleteDevice'"
                ></el-button>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                :content="$t('cameraList.label.update')"
                placement="top"
                popper-class="tooltip-draw"
              >
                <el-button
                  type="text"
                  class="el-icon-refresh"
                  @click="refresh(scope.row)"
                ></el-button>
              </el-tooltip>
            </template>
          </ioc-table>

          <appPanel
            class="app-panel"
            :isExpand="dialogVisible"
            @cancel="dialogVisible = false"
            :title="$t('deviceAccess.title.devdetails')"
          >
            <el-scrollbar>
              <!-- <el-dialog
            :title="$t('deviceAccess.title.devdetails')"
            :visible.sync="dialogVisible"
            v-dialogDrag
            width="1200px"
          > -->
              <span>
                <div class="devDtail" model="devDtail">
                  <div class="devDtailLine">
                    <div class="devDtailAtt">
                      <span class="devDtailTit"
                        >{{ $t("deviceAccess.label.deivceip") }} ：</span
                      >
                      <span class="devDtaildata" :title="devDtail.deviceHost">{{
                        devDtail.deviceHost
                      }}</span>
                    </div>
                    <div class="devDtailAtt">
                      <span class="devDtailTit"
                        >{{ $t("deviceAccess.label.subdevicetype") }} ：</span
                      >
                      <span
                        class="devDtaildata"
                        :title="devDtail.deviceSubType | deviceSubType"
                        >{{ devDtail.deviceSubType | deviceSubType }}</span
                      >
                    </div>
                  </div>
                  <div class="devDtailLine">
                    <div class="devDtailAtt">
                      <span class="devDtailTit"
                        >{{ $t("deviceAccess.label.deivcecode") }} ：</span
                      >
                      <span class="devDtaildata" :title="devDtail.thirdDeviceId">{{
                        devDtail.thirdDeviceId
                      }}</span>
                    </div>
                    <div class="devDtailAtt">
                      <span class="devDtailTit"
                        >{{ $t("deviceAccess.label.cameraname") }} ：</span
                      >
                      <span class="devDtaildata" :title="devDtail.deviceName">{{
                        devDtail.deviceName
                      }}</span>
                    </div>
                  </div>
                  <div class="devDtailLine">
                    <div class="devDtailAtt">
                      <span class="devDtailTit"
                        >{{ $t("deviceAccess.label.parentcode") }} ：</span
                      >
                      <span class="devDtaildata" :title="devDtail.parentDeviceId">{{
                        devDtail.parentDeviceId
                      }}</span>
                    </div>
                    <div class="devDtailAtt">
                      <span class="devDtailTit"
                        >{{ $t("deviceAccess.label.domain") }} ：</span
                      >
                      <span class="devDtaildata" :title="devDtail.domainCode">{{
                        devDtail.domainCode
                      }}</span>
                    </div>
                  </div>
                  <div class="devDtailLine">
                    <div class="devDtailAtt">
                      <span class="devDtailTit"
                        >{{ $t("deviceAccess.label.cameratype") }} ：</span
                      >
                      <span class="devDtaildata" :title="devDtail.deviceTypeName">{{
                        devDtail.deviceTypeName
                      }}</span>
                    </div>
                    <div class="devDtailAtt">
                      <span class="devDtailTit"
                        >{{ $t("deviceAccess.label.location") }} ：</span
                      >
                      <span class="devDtaildata" :title="devDtail.areaDevGroupName">{{
                        devDtail.areaDevGroupName
                      }}</span>
                    </div>
                  </div>
                  <div class="devDtailLine">
                    <div class="devDtailAtt">
                      <span class="devDtailTit"
                        >{{ $t("deviceAccess.label.network") }} ：</span
                      >
                      <span class="devDtaildata" :title="devDtail.netType">{{
                        devDtail.netType
                      }}</span>
                    </div>
                    <div class="devDtailAtt">
                      <span class="devDtailTit"
                        >{{ $t("deviceAccess.label.status") }} ：</span
                      >
                      <span class="devDtaildata" :title="devDtail.status">{{
                        devDtail.status
                      }}</span>
                    </div>
                  </div>
                  <div class="devDtailLine">
                    <div class="devDtailAtt">
                      <span class="devDtailTit"
                        >{{ $t("deviceAccess.label.volice") }} ：</span
                      >
                      <span class="devDtaildata" :title="devDtail.enableVoice">{{
                        devDtail.enableVoice
                      }}</span>
                    </div>
                    <div class="devDtailAtt">
                      <span class="devDtailTit"
                        >{{ $t("deviceAccess.label.supportanalyse") }} ：</span
                      >
                      <span class="devDtaildata" :title="devDtail.isSupportIntelligent">{{
                        devDtail.isSupportIntelligent
                      }}</span>
                    </div>
                  </div>
                  <div class="devDtailLine">
                    <div class="devDtailAtt">
                      <span class="devDtailTit"
                        >{{ $t("deviceAccess.label.creattime") }} ：</span
                      >
                      <span class="devDtaildata" :title="devDtail.createTime | moment">{{
                        devDtail.createTime | moment
                      }}</span>
                    </div>
                    <div class="devDtailAtt">
                      <span class="devDtailTit"
                        >{{ $t("deviceAccess.label.nvr") }} ：</span
                      >
                      <span class="devDtaildata" :title="devDtail.nvrCode">{{
                        devDtail.nvrCode
                      }}</span>
                    </div>
                  </div>
                  <div class="devDtailLine">
                    <div class="devDtailAtt">
                      <span class="devDtailTit"
                        >{{ $t("deviceAccess.label.exdomain") }} ：</span
                      >
                      <span class="devDtaildata" :title="devDtail.isExDomain">{{
                        devDtail.isExDomain
                      }}</span>
                    </div>
                    <div class="devDtailAtt">
                      <span class="devDtailTit"></span>
                      <span class="devDtaildata"></span>
                    </div>
                  </div>
                </div>
              </span>
            </el-scrollbar>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="dialogVisible = false">{{
                $t("deviceAccess.button.close")
              }}</el-button>
            </span>
            <!-- </el-dialog> -->
          </appPanel>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { api } from "../../api/index";
import { Dic } from "$utils";
import utils from "@src/common/utils";
import i18n from "@src/common/lib/i18n";
import appPanel from "@src/components/business/app-panel/index.vue";
export default {
  components: {
    appPanel,
  },
  filters: {
    // 子设备类型过滤
    deviceSubType: function (val) {
      switch (val) {
        case "2":
          return i18n.t("deviceAccess.label.cameradev");
        case "3":
          return i18n.t("deviceAccess.label.langdev");
        case "4":
          return i18n.t("deviceAccess.label.alarmdev");
      }
    },
  },
  data() {
    return {
      showSearch: false,
      tipData: "",
      // 单个删除设备的数据
      delDevSin: {},
      delConfirm: false,
      // 设备详情数据
      devDtail: {
        deviceHost: "",
        thirdDeviceId: "",
        parentCode: "",
        type: "",
        netType: "",
        enableVoice: "",
        deviceCreateTime: "",
        deviceSubType: "",
        isExDomain: "",
        deviceName: "",
        domainCode: "",
        cameraLocation: "",
        status: "",
        isSupportIntelligent: "",
        nvrCode: "",
      },
      // 详情弹框
      dialogVisible: false,
      // 存储列表数据获取方式：1、通过左侧树；2、通过搜索条件；删除时用同样的方式刷新列表数据
      getDevListType: "",
      // 选中设备ID集合
      selDev: [],
      // 查询字段
      queryForm: {
        devNumber: "",
        devId: "",
      },
      // 系统id
      systemId: "",
      platID: "",
      factoryId: "",
      systemName: "",
      deviceType: "",
      // 树的props
      treeProps: {
        label: "thirdDeviceName",
        children: "subDeviceList",
      },
      // 设备树的数据
      frame: [],
      // 树的节点值
      treeKey: "-1",
      // 设备ID
      deviceId: "",
      // 分页属性设置
      devicePage: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      deviceData: [],
      deviceOption: {
        emptyText: this.$t("deviceAccess.message.nodata"),
        stripe: true,
        maxHeight: "100%",
        page: true,
        align: "center",
        menuAlign: "center",
        header: false,
        selection: true,
        delBtn: false,
        editBtn: false,
        column: [
          {
            label: this.$t("deviceAccess.label.cameraname"),
            prop: "deviceName",
            overHidden: true,
          },
          // {
          //   label: this.$t('deviceAccess.label.cameratype'),
          //   prop: 'cameraType',
          //   overHidden:true
          // },
          {
            label: this.$t("deviceAccess.label.maintype"),
            prop: "deviceType",
            overHidden: true,
            formatter: function (row, value) {
              if (row.deviceTypeName) {
                return row.deviceTypeName;
              } else {
                return Dic.findByValue("SENU086", value);
              }
            },
          },
          {
            label: this.$t("deviceAccess.label.area"),
            prop: "areaDevGroupName",
            overHidden: true,
          },
          {
            label: this.$t("deviceAccess.label.status"),
            prop: "status",
            overHidden: true,
            formatter: function (row, value) {
              return Dic.findByValue("SENU015", value);
            },
          },
          {
            label: this.$t("deviceAccess.label.deviceid"),
            prop: "deviceID",
            overHidden: true,
          },
        ],
      },
      level: "",
    };
  },
  created() {
    this.systemId = this.$route.query.systemId;
    this.systemName = this.$route.query.systemName;
    this.platID = this.$route.query.platID;
    this.factoryId = this.$route.query.factoryId;
    this.deviceType = this.$route.query.deviceType;
  },
  mounted() {
    // 请求树根节点
    this.getAccessDeviceInfoTree();
    // 请求设备列表
    this.getDevList();
  },
  methods: {
    handleAdd(){},
    // 返回按钮
    retBtn() {
      this.$router.push("/deviceaccess/index");
      // this.$router.go(-1);
    },
    // 同步数据
    synData() {
      const params = {
        systemId: this.systemId,
        platId: this.platID,
        factoryId: this.factoryId,
        deviceType: this.deviceType,
      };
      // this.$fetch(api.device.synchronVCN, params).then((res) => {
      this.$fetch(api.device.syncDevice, params).then((res) => {
        if (res.success) {
          this.$message.success(res.msgContent);
          this.resetForm();
          // 请求树根节点
          this.getAccessDeviceInfoTree();
          // 请求设备列表
          this.getDevList();
          // 重置搜索条件
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    // 树的子节点点击事件
    currentChange(data, node) {
      this.$log.info("树的子节点点击", data);
      this.treeKey = data.deviceID;
      this.level = node.level;
      if (this.level) {
        this.deviceId = data.deviceID;
      }
      this.getDevList();
    },
    getAccessDeviceInfoTree() {
      const params = {
        systemId: this.systemId,
      };
      this.$fetch(api.device.queryPlatSystemDeviceTree, params).then((res) => {
        if (res.success) {
          this.frame = [res.returnObj];
          this.$nextTick(() => {
            this.$refs.vuetree.setCurrentKey("-1");
          });
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    // 请求数据列表数据
    requestList(param) {
      if (param.parentDeviceId == "-1") {
        param.parentDeviceId = "";
      }
      this.$fetch(api.device.queryPlatSystemDeviceList, param).then((res) => {
        this.deviceData = res.returnObj.list;
        this.devicePage.pageSize = res.returnObj.pageSize;
        this.devicePage.total = res.returnObj.total;
      });
    },
    // 根据查询条件查询列表
    queryDev() {
      this.devicePage.currentPage = 1;
      const params = {
        pageSize: this.devicePage.pageSize,
        pageNum: this.devicePage.currentPage,
        systemId: this.systemId,
        deviceID: this.queryForm.devId,
        deviceName: this.queryForm.devNumber,
        parentDeviceId: this.treeKey,
      };
      this.getDevListType = 1;
      this.requestList(params);
    },
    // 根据树查询设备列表
    getDevList() {
      this.devicePage.currentPage = 1;
      const params = {
        pageSize: this.devicePage.pageSize,
        pageNum: this.devicePage.currentPage,
        systemId: this.systemId,
        deviceID: this.queryForm.devId,
        deviceName: this.queryForm.devNumber,
        parentDeviceId: this.treeKey,
      };
      this.getDevListType = 2;
      this.requestList(params);
    },

    // 批量删除设备
    delDev() {
      if (this.selDev.length === 0) {
        this.$message.warning(this.$t("deviceAccess.message.deltips"));
        return;
      }
      this.delConfirm = true;
      this.$confirm(
        this.$t("deviceAccess.message.uninstall"),
        this.$t("deviceAccess.title.uninstall"),
        {
          confirmButtonText: this.$t("deviceAccess.button.confirm"),
          cancelButtonText: this.$t("deviceAccess.button.cancel"),
          type: "warning",
        }
      ).then(() => {
        this.dlgYes();
      });
    },
    // 单独删除设备
    delDevBtn(row) {
      this.selDev = [row.deviceID];
      this.$confirm(
        this.$t("deviceAccess.message.uninstall"),
        this.$t("deviceAccess.title.uninstall"),
        {
          confirmButtonText: this.$t("deviceAccess.button.confirm"),
          cancelButtonText: this.$t("deviceAccess.button.cancel"),
          type: "warning",
        }
      ).then(() => {
        this.dlgYes();
      });
    },
    // 确认删除
    dlgYes() {
      // if (this.selDev.length === 0) {
      //   this.delConfirm = false;
      // } else {
      this.devicePage.currentPage = 1;
      this.delConfirm = false;
      let params = { deviceIDList: this.selDev };
      // if (this.delDevSin.length == undefined) {
      //   params = {
      //     deviceIDs: this.selDev,
      //   };
      // } else {
      //   params = {
      //     deviceIDs: [this.delDevSin.deviceID],
      //   };
      // }
      this.$fetch(api.device.deletePlatSystemDevice, params).then((res) => {
        if (res.success == true) {
          this.$message.success(this.$t("deviceAccess.message.delsuccess"));
        } else {
          this.$message.error(this.$t("deviceAccess.message.delfail"));
        }
        if (this.getDevListType == 1) {
          this.queryDev();
        } else if (this.getDevListType == 2) {
          this.getDevList();
        }
        this.$refs.devTab.selectClear();
      });
      // }
    },
    // 取消删除
    dlgNo() {
      this.delConfirm = false;
    },

    refresh(row) {
      const params = {
        deviceID: row.deviceID,
      };
      this.$fetch(api.device.queryPlatSystemDeviceDetail, params).then((res) => {
        if (res.success) {
          row.status = res.returnObj.status;
          this.$message.success(res.msgContent);
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },

    //迭代四  新接口 查看详情
    seeDel(row) {
      this.dialogVisible = true;
      const params = {
        deviceID: row.deviceID,
      };
      this.$fetch(api.device.queryPlatSystemDeviceDetail, params).then((res) => {
        if (res.success) {
          this.devDtail = res.returnObj;
          this.devDtail.status = Dic.findByValue("SENU015", res.returnObj.status);
        }
      });
    },
    // 重置搜索
    resetForm() {
      this.devicePage.pageSize = 10;
      this.devicePage.pageNo = 1;
      this.queryForm = {
        devNumber: "",
        devId: "",
      };
      this.getAccessDeviceInfoTree();
      // 请求设备列表
      const params = {
        pageSize: 10,
        pageNum: 1,
        systemId: this.systemId,
        deviceID: this.queryForm.devId,
        deviceName: this.queryForm.devNumber,
        parentDeviceId: this.treeKey,
      };
      this.getDevListType = 2;
      params.parentDeviceId = "";
      this.requestList(params);
      this.devicePage.currentPage = 1;
    },

    // 当选择项发生变化时会触发该事件
    selectionChange(selections) {
      let myAry = [];
      selections.map((item) => {
        myAry.push(item.deviceID);
      });
      this.selDev = myAry;
    },
    // 点击上一页下一页按钮
    selectPage(val) {
      this.devicePage.currentPage = val;
      if (this.getDevListType == 1) {
        const params = {
          pageSize: this.devicePage.pageSize,
          pageNum: this.devicePage.currentPage,
          systemId: this.systemId,
          deviceID: this.queryForm.devId,
          deviceName: this.queryForm.devNumber,
          parentDeviceId: this.treeKey,
        };
        this.getDevListType = 1;
        this.requestList(params);
      } else if (this.getDevListType == 2) {
        const params = {
          pageSize: this.devicePage.pageSize,
          pageNum: this.devicePage.currentPage,
          systemId: this.systemId,
          deviceID: this.queryForm.devId,
          deviceName: this.queryForm.devNumber,
          parentDeviceId: this.treeKey,
        };
        this.getDevListType = 2;
        this.requestList(params);
      }
    },
    // 修改每页数据数量
    changeSize(val) {
      this.devicePage.currentPage = 1;
      this.devicePage.pageSize = val;
      if (this.getDevListType == 1) {
        this.queryDev();
      } else if (this.getDevListType == 2) {
        this.getDevList();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.app-panel {
  right: 16px;
}
.vcnDeviceList {
  width: 100%;
  height: 100%;
  .section-main__warp {
    margin: 0 !important;
  }
}
</style>
<style lang="scss">
@import "~@src/common/assets/style/mixin";

.vcnDevicelist_warpd {
  .el-table__fixed-right-patch {
    display: none;
  }
  .section-main__filter {
    @include set_theme_color(background-color, left-menu-bg-color);
    padding: 10px 20px 10px;
  }
  .devDtaildata {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
